import { render, staticRenderFns } from "./GiftsList.vue?vue&type=template&id=f715f4a0&scoped=true"
import script from "./GiftsList.vue?vue&type=script&lang=js"
export * from "./GiftsList.vue?vue&type=script&lang=js"
import style0 from "./GiftsList.vue?vue&type=style&index=0&id=f715f4a0&prod&lang=scss&scoped=true"
import style1 from "./GiftsList.vue?vue&type=style&index=1&id=f715f4a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715f4a0",
  null
  
)

export default component.exports